
$(document).ready(function() {
$(".text-slide")
  .on('init', function(event, slick){
    $(this).css('display', 'block');
  })
  .slick({
    infinite: true,
    pauseOnFocus: false,
    pauseOnHover: false,
    pauseOnDotsHover: false,
    autoplay: true,
    swipe: false,
    autoplaySpeed: 5000,
    speed: 30000,
    autoplaySpeed: 0,
    cssEase: "linear",
    variableWidth: true,
    arrows: false,
    dots: false,
    responsive: [
      {
        breakpoint: 899,
        settings: {
          speed: 40000,
        },
      },
    ],
  });

$(".text-slide02")
  .on('init', function(event, slick){
    $(this).css('display', 'block');
  })
  .slick({
    infinite: true,
    pauseOnFocus: false,
    pauseOnHover: false,
    pauseOnDotsHover: false,
    autoplay: true,
    swipe: false,
    autoplaySpeed: 5000,
    speed: 30000,
    autoplaySpeed: 0,
    cssEase: "linear",
    variableWidth: false,
    slidesToShow: 1, 
    arrows: false,
    dots: false,
    responsive: [
      {
        breakpoint: 899,
        settings: {
          speed: 40000,
          slidesToShow: 0.8, 
        },
      },
    ],
  });

  
  $(".slide").slick({
    fade: true,
    speed: 1500,
    autoplaySpeed: 2500,
    arrows: false,
    autoplay: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: true,
    dots: true,
  });

  
  $(".slide-initialized").slick({
        // autoplay: true,
        // autoplaySpeed: 0,
        // speed: 8000,
        // cssEase: 'linear',
        // arrows:false,
        // swipe: false,
        // pauseOnFocus: false,
        // pauseOnHover: false,
        // centerMode: true,
        // initialSlide: 3,
        // variableWidth: true,

        	arrows: false,
                autoplaySpeed: 30,
                cssEase: "linear",
                swipe: false,
                infinite: true,
                speed: 8000,
                autoplay: true,
                pauseOnFocus: false,
                pauseOnHover: false,
                centerMode: true,
                slidesToShow: 1,
                centerPadding: '30%',
                variableWidth: true,
  });
  $('.slide-initialized').css('display', 'block');
});


var scrollFuncs = {};

scrollFuncs.fadePic = function () {
  $(window).bind("scroll", function () {
    var scrollY = $(window).scrollTop();
    var windowHeight = screen.availHeight;

    // Define an array of slide classes and their delays
    var slideClasses = ['.slide01', '.slide02', '.slide03', '.slide04'];
    var slideDelays = [0, 200, 400, 600]; // Corresponding delay times in milliseconds

    for (var i = 0; i < slideClasses.length; i++) {
      var slideImage = $(slideClasses[i]);
      if (slideImage.length > 0) {
        slideImage.each(function () {
          var slideImageY = $(this).offset().top;

          if (scrollY > slideImageY - windowHeight * 0.6) {
            // Wrap adding class in setTimeout function with delay
            var $this = $(this); // Preserve 'this' reference
            setTimeout(function () {
              $this.addClass("is-animated");
            }, slideDelays[i]); // Use corresponding delay from array
          }
        });
      }
    }
  });
};

function scrollInit() {
  scrollFuncs.fadePic();
  // scrollFuncs.parallax();
}

// ページ読み込み時にscrollInit関数を呼び出す
$(document).ready(scrollInit);




document.addEventListener("DOMContentLoaded", function () {
  const mm = gsap.matchMedia();

  mm.add("(min-width: 1000px)", () => {
    gsap.to(".lp-no2-img01", {
      scrollTrigger: {
        trigger: ".lp-no2-img01",
        pin: true,
        start: "top 80px",
        pinSpacing: false,

        endTrigger: ".lp-no2-img03",
        end: "top 620px",
      },
    });
    gsap.to(".lp-no2-img02", {
      scrollTrigger: {
        trigger: ".lp-no2-img02",
        pin: true,
        start: "top 340px",
        pinSpacing: false,

        endTrigger: ".lp-no2-img03",
        end: "top 620px",
      },
    });
    gsap.to(".pin-container", {
      scrollTrigger: {
        trigger: ".pin-container",
        pin: true,
        start: "center center",
        pinSpacing: false,

        endTrigger: ".lp-no6-img02",
        end: "center center",
      },
    });

    gsap.to(".lp-no10-img01", {
      scrollTrigger: {
        trigger: ".lp-no10-img01",
        pin: true,
        start: "top 80px",
        pinSpacing: false,

        endTrigger: ".lp-no10-img02 img",
        end: "top 270px",
      },
    });
  });

  const windowSize = window.innerWidth;
  const startOffset01 = Math.floor(windowSize * 0.5 + 50);
  const startOffset02 = Math.floor(windowSize * 1.08 + 50);

  mm.add("(max-width: 999px)", () => {
    ScrollTrigger.create({
      trigger: ".lp-no2-img01",
      pin: true,
      start: "top 80px",
      pinSpacing: false,
      endTrigger: ".lp-no2-img03",
      end: "top " + startOffset02 + "px",
    });

    ScrollTrigger.create({
      trigger: ".lp-no2-img02",
      pin: true,
      start: "top " + startOffset01 + "px",
      pinSpacing: false,
      endTrigger: ".lp-no2-img03",
      end: "top " + startOffset02 + "px",
    });

    ScrollTrigger.create({
      trigger: ".pin-container",
      pin: true,
      start: "center center",
      pinSpacing: false, // pinSpacingをfalseに変更
      anticipatePin: 1,
      endTrigger: ".lp-no6-img02 img",
      end: "center center",
    });
  });
});



